/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-misused-promises */
import AuthApiService from '@package/core/src/auth/AuthApiService';

import ApiClient from '../ApiClient';
import CookieStorage from '../Storage/Cookie';

import {
  ApplyProductsRequest,
  ApplyCustomerRequest,
  ApplyShippingCustomerRequest,
  ApplyOrderRequest,
  ListrakAnalyticI,
} from './types';

export default class ListrakAnalytic extends AuthApiService implements ListrakAnalyticI {
  public constructor(protected apiClient: ApiClient, protected cookies: CookieStorage) {
    super(apiClient);
  }

  private getListrak() {
    return typeof window !== 'undefined' ? window._ltk : undefined;
  }

  private async getOrderKey(): Promise<any> {
    const { data: orderKey } = await this.cookies.get('order_key');
    return orderKey;
  }

  public async applyProducts(request: ApplyProductsRequest) {
    const { products, total } = request;

    const listrak = this.getListrak();

    if (listrak) {
      const orderKey = (await this.getOrderKey()) || 'orderKey';

      if (products?.length === 0) return listrak.SCA.ClearCart();
      products?.forEach((product) => {
        if (product) {
          listrak.SCA.AddItemWithLinks(
            product.id,
            product.quantity,
            product.price.toString(),
            product.name,
            product.image,
            product.productUrl,
          );
        }
      });

      listrak.SCA.Meta1 = orderKey;
      listrak.SCA.Meta2 = total;

      listrak.SCA.Submit();
    } else {
      console.warn('No Listrak was provided');
    }
  }

  public async applyCustomer(request?: ApplyCustomerRequest) {
    const listrak = this.getListrak();

    if (listrak) {
      const { data: user } = await this.getUser();

      listrak.SCA.SetCustomer(user?.sub || request?.email, user?.firstName, user?.lastName);
      listrak.SCA.Submit();

    } else {
      console.warn('No Listrak was provided');
    }
  }

  public async applyShippingCustomer(request: ApplyShippingCustomerRequest) {
    const listrak = this.getListrak();

    if (listrak && request.firstName && request.lastName) {
      const { firstName, lastName } = request;
      const { data: user } = await this.getUser();

      listrak.SCA.CaptureEmail('emailAddress');
      listrak.SCA.Stage = 3;
      listrak.SCA.SetCustomer(user?.sub, firstName, lastName);
      listrak.SCA.Submit();

    } else {
      console.warn('No Listrak was provided');
    }
  }

  public async applyOrder(request: ApplyOrderRequest) {
    const listrak = this.getListrak();

    if (listrak) {
      const { suborders, user } = request;
      const orderKey = await this.getOrderKey();

      suborders.forEach(async (suborder: any) => {
        if (listrak) {
          listrak.Order.SetCustomer(user.email, user.firstName, user.lastName);
          listrak.Order.OrderNumber = suborder.orderNumber.toString();
          listrak.Order.ItemTotal = suborder.itemTotal.toString();
          listrak.Order.ShippingTotal = suborder.shippingTotal.toString();
          listrak.Order.TaxTotal = suborder.taxTotal.toString();
          listrak.Order.OrderTotal = suborder.orderTotal.toString();
          listrak.Order.HandlingTotal = '0.0';
          suborder.products.forEach((product: any) => {
            listrak?.Order.AddItem(product.sku, product.quantity, product.price.toString());
          });
          await listrak.Order.Submit();

        } else {
          console.warn('No Listrak was provided');
        }
      });
    }
  }
}
